import { Controller } from "@hotwired/stimulus";

// Enables the Key findings status table "Apply" button when Facility IDs or Matrix IDs are set.
export default class extends Controller {
  static targets = ["facilityIds", "matrixIds", "submit"];

  connect() {
    this.syncSubmitState();
  }

  // Re-render the dashboard as soon as an admin toggles a test calculation's
  // "Include in analytics" checkbox. Use submit() rather than requestSubmit()
  // so a disabled Apply button cannot block the GET reload.
  submitInclusion() {
    this.element.submit();
  }

  syncSubmitState() {
    if (!this.hasSubmitTarget) return;

    const enabled = this.isReady();
    this.submitTarget.disabled = !enabled;
    this.submitTarget.classList.toggle("cursor-not-allowed", !enabled);
    this.submitTarget.classList.toggle("opacity-60", !enabled);
    this.submitTarget.classList.toggle("hover:opacity-90", enabled);
  }

  isReady() {
    return this.facilityIdsValuePresent() || this.matrixIdsValuePresent();
  }

  facilityIdsValuePresent() {
    if (!this.hasFacilityIdsTarget) return false;
    return this.facilityIdsTarget.value.trim().length > 0;
  }

  matrixIdsValuePresent() {
    if (!this.hasMatrixIdsTarget) return false;
    return this.matrixIdsTarget.value.trim().length > 0;
  }
}
